import { useTranslation } from "react-i18next";
import { SelectField } from "@/shared/ui/core";
import { FormSection, NumberField, useStatusOptions } from "@/features/admin/components";
import { PackageSlugField } from "./PackageSlugField";

export interface PackageCatalogSectionProps {
  /** `true` al editar: bloquea el slug. */
  locked: boolean;
}

/**
 * Dónde vive el paquete: su dirección, si se ve y en qué orden.
 *
 * El estado es un campo del formulario y no un botón aparte a propósito.
 * "Publicar" como acción suelta convierte el estado en algo que se
 * cambia sin guardar el resto, y entonces se publica una versión que no
 * es la que está en pantalla. Aquí publicar es guardar.
 */
export function PackageCatalogSection({ locked }: PackageCatalogSectionProps) {
  const { t } = useTranslation();
  const statusOptions = useStatusOptions();

  return (
    <FormSection
      title={t("Dirección en la tienda")}
      description={t("La parte legible de la URL. Se elige una vez y no se cambia.")}
      columns={2}
    >
      <PackageSlugField locked={locked} />

      <SelectField
        name="status"
        label={t("Estado")}
        options={statusOptions}
        hint={t("Un paquete nuevo nace como borrador: nadie lo ve hasta publicarlo.")}
      />

      <NumberField
        name="sortOrder"
        label={t("Orden")}
        placeholder="0"
        hint={t("El número más bajo aparece primero.")}
        className="text-right tabular-nums"
      />
    </FormSection>
  );
}
